import ConnectApi from "../../baseService"
import {
  TKaikonZyutyuHaisyaListGetReq,
  TKaikonZyutyuHaisyaListGetRes,
  TKaikonZyutyuHaisyaGetRes,
  TKaikonZyutyuHaisyaTableGetRes,
  TKaikonZyutyuHaisyaPrintHaisyahyoReq,
} from "./TKaikonZyutyuHaisya"
import { AxiosResponse, AxiosError } from "axios"
import { TApiResponse } from "../../TApiResponse"

/**
 * 海コン受注配車に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class KaikonZyutyuHaisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TKaikonZyutyuHaisyaListGetReq} params
   * @memberof MenuService
   */
  getList = async (params: TKaikonZyutyuHaisyaListGetReq<any>) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaikonZyutyuHaisyaListGetRes[]>> =
        await this.getInner(`/ordercontainer/kaikonzyutyuhaisya`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 配車表取得
   *
   * @memberof MenuService
   */
  getHaisyaHyo = async (params: TKaikonZyutyuHaisyaListGetReq<any>) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaikonZyutyuHaisyaTableGetRes[]>> =
        await this.getInner(
          `/ordercontainer/kaikonzyutyuhaisya/haisyahyo`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @memberof MenuService
   */
  get = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaikonZyutyuHaisyaGetRes>> =
        await this.getInner(`/ordercontainer/kaikonzyutyuhaisya/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TKaikonZyutyuHaisyaGetRes) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/ordercontainer/kaikonzyutyuhaisya`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, data: TKaikonZyutyuHaisyaGetRes) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/ordercontainer/kaikonzyutyuhaisya/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * グリッド登録
   *
   * @param {TKaikonZyutyuHaisyaListGetRes} params
   * @memberof kaikonZyutyuHaisyaService
   */
  putList = async (params: TKaikonZyutyuHaisyaListGetRes[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/ordercontainer/kaikonzyutyuhaisya/upsertlist`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * グリッド削除
   *
   * @param {TKaikonZyutyuHaisyaListGetRes} params
   * @memberof kaikonZyutyuHaisyaService
   */
  deleteList = async (params: { 受注配車ID: number }[]) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaikonZyutyuHaisyaListGetRes[]>> =
        await this.putInner(
          `/ordercontainer/kaikonzyutyuhaisya/deletelist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TKaikonZyutyuHaisyaGetRes} data
   * @memberof KaikonZyutyuHaisyaService
   */
  delete = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/ordercontainer/kaikonzyutyuhaisya/actions/delete/${id}`,
        id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 海コン配車表印刷
   *
   * @param {TKaikonZyutyuHaisyaPrintHaisyahyoReq} params
   * @memberof KaikonZyutyuHaisyaService
   */
  printHaisyahyo = async (
    params: TKaikonZyutyuHaisyaPrintHaisyahyoReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G041202`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
